export default "__VITE_ASSET__BSKkl3$T__"